<h3-navbar></h3-navbar>
@if ((modelsLoading$ | async) === 'loaded') {
  <h3-root-h3ml-container></h3-root-h3ml-container>

  <hr />

  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title><strong>Example input values</strong></mat-panel-title>
    </mat-expansion-panel-header>
    <div class="inputs">
      <ng-container *ngFor="let input of project.inputs">
        <span>{{ input.name }}</span>
        <h3-input [nasModel]="questionStore(input.name)"></h3-input>
      </ng-container>
    </div>
  </mat-expansion-panel>
}
